import React, {memo} from 'react'
import classNames from "classnames";
import Style from "./FJToolButton.module.less";

function FJToolButton(props) {

  let {active, icon, text, onClick} = props;
  let cn = classNames(active ? Style.active : '', Style.title_item);
  return (
    <button onClick={onClick} className={cn}>
      {icon}
      <span>{text}</span>
    </button>
  )
}

export default memo(FJToolButton);